(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityEmbeddedEditCtrl', EntityEmbeddedEditCtrl);

    EntityEmbeddedEditCtrl.$inject = ['$scope', 'entityFields', 'entityTemplate', 'fieldTypes', 'entityTemplates', 'fileAttachmentList', 'DialogInstance'];


    /**
     * @ngdoc controller
     * @name EntityEmbeddedEditCtrl
     * 
     * @description
     * For editing an existing embedded entity or creating a new one.
     * 
     */
    function EntityEmbeddedEditCtrl($scope, entityFields, entityTemplate, fieldTypes, entityTemplates, fileAttachmentList, DialogInstance) {
        /* jshint validthis:true */
        var vm = this;
        vm.fileAttachmentList = fileAttachmentList;
        vm.generateLabel = generateLabel;
        vm.fieldTypes = fieldTypes;
        vm.entityTemplates = entityTemplates;
        vm.entity = newEntity();
        vm.newEntity = false;
        vm.ok = ok;
        vm.cancel = cancel;
        activate();

        function activate() {
            if (entityFields != 'new') {
                // The value is copied, we do not want to directly bind otherwise the source value will be changed even if the dialog is cancelled
                vm.entity.Fields = angular.copy(entityFields);
                vm.entity.EntityTemplate = angular.copy(entityTemplate);
            } else {
                vm.newEntity = true;
                vm.entity.EntityTemplate = angular.copy(entityTemplate);
                setDefaultValues();
            }
        }

        function ok() {
            DialogInstance.ok(vm.entity.Fields);
        }

        function cancel() {
            DialogInstance.cancel();
        }

        function newEntity() {
            return {
                Fields: {},
                EntityTemplate: {}
            };
        }

        function setDefaultValues() {
            // Sets the default value for a field if it exists
            angular.forEach(entityTemplate.Fields, function (fieldTemplate) {
                if ('Default' in fieldTemplate) {
                    vm.entity.Fields[fieldTemplate.Name] = fieldTemplate.Default;
                }
                else {
                    vm.entity.Fields[fieldTemplate.Name] = null;
                }
            });
        }

        function generateLabel() {
            if (angular.isDefined($scope.title) && $scope.title !== null && $scope.title !== '') {
                return $scope.title;
            }

            var result = '';

            if (vm.newEntity) {
                result = 'Add ';
            }

            result = result + vm.entity.EntityTemplate.Name;

            return result;
        }
    }
})();
